/**
 * In-browser FEAGI embodiment stack: Brain Visualizer, Play sessions, Trainer,
 * webcam/screen/Bluetooth bridges, and related WebSockets to the FEAGI cluster.
 *
 * Set NEXT_PUBLIC_NRS_FEAGI_EMBODIMENT_ENABLED=true to enable. When unset or
 * false, those routes and UI are disengaged so the portal does not open device
 * or FEAGI WebSocket connections.
 */
export function isFeagiEmbodimentIntegrationEnabled() {
  return process.env.NEXT_PUBLIC_NRS_FEAGI_EMBODIMENT_ENABLED === "true";
}
